<template>
  <div class="underline">
    <div class="banner">
      <img src="../../assets/images/underline/banner.png" alt />
    </div>
    <!-- 选择品牌 -->
    <div class="brand">
      <!-- 分页 -->
      <div class="paging">
        <div class="title">
          选择品牌
          <br />查看案例
        </div>
        <span class="number">
          <strong v-if="queryInfo.page < 10">0{{queryInfo.page + 1}}</strong>
          <strong v-else>0{{queryInfo.page + 1}}</strong>/
          <b v-if="page < 10">0{{ page }}</b>
          <b v-else>{{ page }}</b>
        </span>
        <div class="switch">
          <span @click="lastPage()">
            <img src="../../assets/images/company/left.png" alt />
          </span>
          <span @click="nextPage()">
            <img src="../../assets/images/company/right.png" alt />
          </span>
        </div>
      </div>
      <!-- logo列表 -->
      <ul class="brandList">
        <li v-for="(item, i) in brandList" :key="i" @click="brandCase(item.id), cases = 0">
          <img :src="address + item.brandImg" alt />
        </li>
      </ul>
    </div>
    <!-- 案例列表 -->
    <div class="caseList">
      <!-- 列表菜单 -->
      <div class="caseMenu">
        <ul v-if="cases == 0" class="caseMenuList">
          <li
            v-for="(item, i) in brandCaseList"
            :class="{ active : active === i }"
            :key="i"
            @click="active = i, setbrandCaseListImg(item)"
          >{{item.title}}</li>
        </ul>
         <!-- 首页点击进来的列表 -->
        <ul v-else-if="cases == 1" class="caseMenuList">
          <li
            class="active"
          >{{caseItem.title}}</li>
        </ul>
      </div>
      <el-carousel
        :height="bannerHeight"
        :interval="5000"
        arrow="always"
        :autoplay="false"
        ref="carousel"
      >
        <el-carousel-item v-for="item in brandCaseListImg" :key="item">
          <img :src="address + item" alt />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="dolls">
      <!-- 活动说明 -->
      <div class="plate">
        <div class="plateContent">
          <div class="title">活动说明</div>
          <p class="text">{{brandText.explain}}</p>
        </div>
      </div>
      <!-- 活动成果 -->
      <div class="plate">
        <div class="plateContent">
          <div class="title">活动说明</div>
          <p class="text">{{brandText.achievements}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth,
      active: 0,
      // 查询参数对象
      queryInfo: {
        query: '',
        // 当前页
        page: 0,
        size: 12,
        sort: 'id,asc'
      },
      brandList: [],
      // 总条数
      total: 0,
      // 总页数
      page: 0,
      address: 'http://uploads.i-mineral.cn/',
      // 品牌案例
      brandCaseList: [],
      // 品牌图片
      brandCaseListImg: [],
      // 品牌文案
      brandText: {
        explain: '',
        achievements: ''
      },
      cases: 0,
      caseItem: {
        title: '',
        img: '',
        result: '',
        remark: ''
      }
    }
  },
  created() {
    this.getBrandList()
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    if (window.sessionStorage.getItem('title') !== null) {
      this.caseItem.img = window.sessionStorage.getItem('img')
      this.caseItem.title = window.sessionStorage.getItem('title')
      this.caseItem.result = window.sessionStorage.getItem('result')
      this.caseItem.remark = window.sessionStorage.getItem('remark')
      this.cases = 1
      console.log(this.caseItem)
    }
  },
  methods: {
    async getBrandList() {
      if (this.screenWidth < 850) {
        this.queryInfo.size = 4
      }
      const { data: res } = await this.$http.get('/api/item/offlinebrand', {
        params: this.queryInfo
      })
      if (res.content === null) {
        return this.$message.error('获取品牌列表失败！')
      }
      this.brandList = res.content
      this.total = res.totalElements
      this.page =
        this.total % this.queryInfo.size === 0
          ? this.total / this.queryInfo.size
          : parseInt(this.total / this.queryInfo.size) + 1
      this.brandCase(this.brandList[0].id)
    },
    // 上一页
    lastPage() {
      this.cases = 0
      if (this.queryInfo.page > 0) {
        this.queryInfo.page--
        this.getBrandList()
      }
    },
    // 下一页
    nextPage() {
      this.cases = 0
      if (this.queryInfo.page + 1 < this.page) {
        this.queryInfo.page++
        this.getBrandList()
      }
    },
    // 品牌详情
    async brandCase(id) {
      const { data: res } = await this.$http.get(
        '/api/BrandProject?brandId=' + id
      )
      if (res.content === null) {
        return this.$message.error('获取品牌列表失败！')
      }
      this.brandCaseList = res.content
      if (this.cases > 0) {
        this.setbrandCaseListImg(this.caseItem)
        window.sessionStorage.removeItem('title')
      } else {
        this.setbrandCaseListImg(this.brandCaseList[0])
      }
    },
    setbrandCaseListImg(item) {
      // 品牌图片
      this.brandCaseListImg = item.img.split(',')
      // 品牌文案
      this.brandText.explain = item.remark
      this.brandText.achievements = item.result
    }
  },
  computed: {
    bannerHeight() {
      if (this.screenWidth >= 850) {
        return '490px'
      } else {
        return '220px'
      }
    }
  }
}
</script>

<style scoped>
.underline {
  width: 100%;
}
.underline .banner {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
}
.underline .banner img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: auto;
  height: 100%;
}
/* 选择品牌 */
.underline .brand {
  width: 100%;
  height: 250px;
  max-width: 1100px;
  margin: 20px auto;
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  overflow: hidden;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.underline .brand .paging {
  height: 100%;
  width: 100px;
}
.brand .paging .title {
  font-size: 24px;
  font-weight: 400;
  position: relative;
}
.brand .paging .title::after {
  content: '';
  display: block;
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 50px;
  height: 4px;
  background-color: rgb(235, 89, 25);
}
.brand .paging .number {
  display: inline-block;
  margin-top: 20px;
  font-size: 30px;
  font-weight: 400;
  width: 110px;
}
.brand .paging .number strong {
  font-size: 38px;
  font-weight: 600;
}
.brand .paging .switch {
  width: 100px;
  background-color: rgb(235, 89, 25);
  height: 40px;
}
.brand .paging .switch span {
  display: inline-block;
  width: 50%;
  height: 100%;
  position: relative;
}
.brand .paging .switch span:hover {
  background-color: #727272;
}
.brand .paging .switch span img {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
/* 品牌列表 */
.brand .brandList {
  padding: 10px;
  margin-left: 20px;
  height: 230px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  box-sizing: border-box;
}
@media screen and (min-width: 850px) {
  .brand .brandList li {
    width: 152px;
    height: 116px;
    border: 1px solid #abaaaa;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}
@media screen and (max-width: 849px) {
  .brand .brandList li {
    width: 106px;
    height: 100px;
    border: 1px solid #abaaaa;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .brand .brandList {
    margin-left: 0px;
    overflow: hidden;
  }
}
.brand .brandList li img {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: width100_80 1s;
}
.brand .brandList li:hover img {
  animation: width80_100 1s forwards;
}
.underline .caseList {
  width: 100%;
  max-width: 1100px;
  margin: 30px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.underline .caseList .el-carousel {
  flex: 1;
  min-width: 320px;
}
.underline .caseList .el-carousel img {
  width: 100%;
}
@media screen and (min-width: 850px) {
  .underline .caseList {
    height: 490px;
  }
  .underline .caseList .caseMenu {
    width: 250px;
    height: 490px;
    position: relative;
  }
  .underline .caseList .caseMenu::after {
    content: '';
    display: block;
    height: 100%;
    width: 20px;
    background: rgb(235, 89, 25);
    position: absolute;
    top: 0;
    right: 0;
  }
  .underline .caseList .caseMenu li {
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    padding-left: 20px;
    cursor: pointer;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .underline .caseList .caseMenu li.active {
    background-color: rgb(235, 89, 25);
    color: #fff;
  }
}
@media screen and (max-width: 849px) {
  .underline .caseList .caseMenu {
    width: 100%;
  }
  .underline .caseList .caseMenu li {
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    padding-left: 20px;
    cursor: pointer;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .underline .caseList .caseMenu li.active {
    background-color: rgb(235, 89, 25);
    color: #fff;
  }
}
/* 活动文字描述 */
.underline .dolls {
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
}
.underline .dolls .plate {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}
.underline .dolls .plate .plateContent {
  width: 100%;
  max-width: 850px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
}
.plate .plateContent .title {
  width: 100%;
  text-align: center;
  position: relative;
  font-size: 22px;
  font-weight: 600;
}
.plate .plateContent .title::after {
  content: '';
  display: block;
  width: 60px;
  height: 4px;
  background-color: rgb(235, 89, 25);
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translate(-50%, 0);
}
.plate .plateContent .text {
  margin-top: 20px;
  width: 100%;
  font-size: 16px;
  text-align: left;
}
.plate .plateContent img {
  width: 100px;
  height: 100px;
  margin-top: 20px;
}
</style>
